<template>
  <div class="admin-room-container figma-property-page">
    <div class="figma-white-card">
      <div class="figma-page-header">
        <div class="figma-page-title">{{ $t('committeeAreaFeedback.pageTitle') }}</div>
        <div class="figma-header-divider"></div>
        <div class="figma-header-row">
          <div class="figma-btn-group">
            <el-button size="small" class="figma-btn-refresh" title="刷新" @click="getList">
              <i class="el-icon-refresh-right"></i>
            </el-button>
          </div>
          <div class="figma-search-group">
            <el-input size="small" v-model="conditions.keyword" :placeholder="$t('committeeAreaFeedback.search.keywordPlaceholder')" class="figma-search-input" clearable @keyup.enter.native="handleSearch" />
            <el-button size="small" class="figma-btn-search" @click="handleSearch">
              <i class="el-icon-search"></i>搜索
            </el-button>
          </div>
        </div>
      </div>

      <div class="figma-table-section">
        <el-table :data="tableData" style="width: 100%" :header-cell-style="headerCellStyle" :cell-style="cellStyle">
          <el-table-column prop="id" :label="$t('committeeAreaFeedback.table.id')" min-width="62" show-overflow-tooltip />
          <el-table-column prop="communityName" :label="$t('committeeAreaFeedback.table.communityName')" min-width="132" show-overflow-tooltip />
          <el-table-column prop="roomNum" :label="$t('committeeAreaFeedback.table.roomNum')" min-width="80" show-overflow-tooltip />
          <el-table-column prop="builtUpArea" :label="$t('committeeAreaFeedback.table.builtUpArea')" min-width="110" show-overflow-tooltip />
          <el-table-column prop="roomArea" :label="$t('committeeAreaFeedback.table.roomArea')" min-width="110" show-overflow-tooltip />
          <el-table-column prop="feedbackArea" :label="$t('committeeAreaFeedback.table.feedbackArea')" min-width="110" show-overflow-tooltip />
          <el-table-column prop="ownerName" :label="$t('committeeAreaFeedback.table.ownerName')" min-width="100" show-overflow-tooltip />
          <el-table-column prop="state" :label="$t('committeeAreaFeedback.table.state')" min-width="80" show-overflow-tooltip />
          <el-table-column prop="createTime" :label="$t('committeeAreaFeedback.table.createTime')" min-width="194" show-overflow-tooltip />
          <el-table-column :label="$t('committeeAreaFeedback.table.action')" min-width="120" align="center">
            <template slot-scope="scope">
              <div class="action-links">
                <el-button type="text" size="small" @click="handleDetail(scope.row)">{{ $t('committeeAreaFeedback.action.detail') }}</el-button>
                <el-button type="text" size="small" @click="handleFeedback(scope.row)">{{ $t('committeeAreaFeedback.action.handle') }}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="figma-pagination-section">
        <el-pagination background layout="total, prev, pager, next, sizes" :total="pagination.total" :current-page="pagination.page" :page-size="pagination.row" :page-sizes="[10, 20, 50]" @current-change="handlePageChange" @size-change="handleSizeChange" />
      </div>
    </div>
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { listCommunitysByOwnerCommittee } from '@/api/owner/ownerCommitteeManageApi'
import { listAreaFeedback, handleAreaFeedback, getAreaFeedbackDetail } from '@/api/committee/areaFeedbackApi'

export default {
  name: 'CommitteeAreaFeedbackList',
  data() {
    return {
      loading: false,
      conditions: { keyword: '' },
      tableData: [],
      pagination: { total: 0, page: 1, row: 10 }
    }
  },
  created() { this.getList() },
  methods: {
    headerCellStyle() { return { background: '#EBF2FA', color: '#364153', fontWeight: 400, fontSize: '14px' } },
    cellStyle() { return { fontSize: '14px' } },
    isSuccess(res) { return res && (res.code === 0 || res.code === 200 || res.code === '0' || res.code === '200' || res.success || res.msg === 'success') },
    getListArray(res) {
      if (Array.isArray(res)) return res
      if (Array.isArray(res && res.data)) return res.data
      if (Array.isArray(res && res.records)) return res.records
      return []
    },
    getTotal(res, list) { return Number((res && (res.total || res.count || res.totalCount)) || list.length || 0) },
    async getList() {
      try {
        this.loading = true
        const communityRes = await listCommunitysByOwnerCommittee({ page: 1, row: 1000 })
        const communityList = communityRes.data || communityRes.records || communityRes.rows || []
        const communityIds = communityList.map(c => c.communityId).filter(Boolean).join(',')
        const params = { page: this.pagination.page, row: this.pagination.row, keyword: this.conditions.keyword }
        if (communityIds) {
          params.communityIds = communityIds
        }
        const res = await listAreaFeedback(params)
        const list = this.getListArray(res)
        this.tableData = list
        this.pagination.total = this.getTotal(res, list)
      } catch (e) {
        this.$message.error('获取面积反馈列表失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() { this.pagination.page = 1; this.getList() },
    handleDetail(row) { /* TODO */ },
    handleFeedback(row) {
      this.$confirm(this.$t('committeeAreaFeedback.dialog.handleTitle'), { type: 'info' }).then(() => {
        this.$message.success(this.$t('committeeAreaFeedback.dialog.handleSuccess'))
        this.getList()
      }).catch(() => {})
    },
    handlePageChange(page) { this.pagination.page = page; this.getList() },
    handleSizeChange(size) { this.pagination.row = size; this.pagination.page = 1; this.getList() }
  }
}
</script>

<style scoped>
.admin-room-container { padding: 20px; height: 100%; box-sizing: border-box; }
.figma-white-card { background: white; border-radius: 12px; padding: 20px 24px; height: 100%; display: flex; flex-direction: column; }
.figma-page-header { flex-shrink: 0; }
.figma-page-title { font-size: 16px; font-weight: 600; color: #1D2129; margin-bottom: 12px; }
.figma-header-divider { height: 1px; background: #EBF2FA; margin-bottom: 12px; }
.figma-header-row { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; }
.figma-btn-group { display: flex; gap: 8px; }
.figma-btn-refresh { background: white !important; border-color: #DCE6F5 !important; color: #364153 !important; border-radius: 10px !important; }
.figma-search-group { display: flex; gap: 8px; align-items: center; }
.figma-search-input { width: 256px; }
.figma-btn-search { background: white !important; border-color: #0E76FF !important; color: #0E76FF !important; border-radius: 10px !important; }
.figma-table-section { flex: 1; margin-top: 12px; overflow: auto; }
.figma-pagination-section { display: flex; justify-content: flex-end; padding-top: 16px; flex-shrink: 0; }
.action-links { display: flex; align-items: center; justify-content: center; gap: 8px; }
</style>
